var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1130_27207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1130_27207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 23L5.8 8.9L4 9.6V13H2V8.3L7.05 6.15C7.53333 5.95 8.025 5.92917 8.525 6.0875C9.025 6.24583 9.41667 6.55 9.7 7L10.7 8.6C11.15 9.31667 11.7458 9.89583 12.4875 10.3375C13.2292 10.7792 14.0667 11 15 11V13C13.9 13 12.8708 12.7708 11.9125 12.3125C10.9542 11.8542 10.15 11.25 9.5 10.5L8.9 13.5L11 15.5V23H9V17L6.9 15L5.1 23H3ZM9.5 5.5C8.95 5.5 8.47917 5.30417 8.0875 4.9125C7.69583 4.52083 7.5 4.05 7.5 3.5C7.5 2.95 7.69583 2.47917 8.0875 2.0875C8.47917 1.69583 8.95 1.5 9.5 1.5C10.05 1.5 10.5208 1.69583 10.9125 2.0875C11.3042 2.47917 11.5 2.95 11.5 3.5C11.5 4.05 11.3042 4.52083 10.9125 4.9125C10.5208 5.30417 10.05 5.5 9.5 5.5ZM19.5 23L18.45 21.95L19.15 21.25H14V19.75H19.15L18.45 19.05L19.5 18L22 20.5L19.5 23ZM16.5 18.75L14 16.25L16.5 13.75L17.55 14.8L16.85 15.5H22V17H16.85L17.55 17.7L16.5 18.75Z",
    fill: "#616161"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/Transfer_Icon.2ff91634bd0053244085576dc7aa40a2.svg";
export { ForwardRef as ReactComponent };